export type SuspenseContextType = {
    [key: string]: {
        step: 'blank' | 'processing' | 'done';
        target: any;
        awaiter?: Promise<void>;
    }
};

export class Suspense {
    value: SuspenseContextType

    constructor() {
        this.value = {};
    }

    get(key: string) {
        return this.value[key];
    }

    drop(key: string) {
        delete this.value[key];
    }

    ensure(key: string) {
        if (!this.value[key]) {

            this.value[key] = {
                step: 'blank',
                target: undefined,
                awaiter: undefined,
            };
        }
    }

    clear() {
        for (const key in this.value) {
            delete this.value[key];
        }
    }
}